<script>
  import LogEntry from './LogEntry.svelte';
  import TagTable from './TagTable.svelte';
  import KeyHandler from './components/KeyHandler.svelte';
  import api from './api.js';

  export let sid = '';

  let lineN = Number(window.location.hash.slice(1));

  const selectLine = n => {
    if (n < 1) n = 1;
    if (n > entries.length) n = entries.length;
    lineN = n;
    const loc = document.location.pathname + document.location.search;
    history.replaceState(null, null, `${loc}#${n}`);
  };

  const lineUp = () => selectLine(lineN-1);
  const lineDown = () => selectLine(lineN+1);
  const pageUp = () => selectLine(lineN-10);
  const pageDown = () => selectLine(lineN+10);
  const expand = () => entries[lineN-1].expand++;

  const keyHandlers = {
    'ArrowDown': lineDown,
    'ArrowUp': lineUp,
    'PageDown': pageDown,
    'PageUp': pageUp,
    'Enter': expand,
    'Space': expand,
	};

  let session;
  const load = async () => {
    session = await api.GET(`/session/${sid}`);
    session.logs.map(x => x.expand = 3);
  }
  load();

  const tsOffset = ts => new Date(ts) - new Date(session.start);

  $: tags = session?.tags || {};
  $: entries = session?.logs || [];
  $: appName = session?.appname || '';
  $: sid = session?.id.slice(-8) || '';
</script>

<svelte:head>
  <title>{appName} {sid}</title>
</svelte:head>

<KeyHandler handlers={keyHandlers} />
<div>
  <TagTable {tags} />
  {#each entries as x, i}
    <LogEntry
      n={i+1}
      isSelected={i+1 === lineN}
      selectLine={selectLine}
      offset={tsOffset(x.ts)}
      {...x}
    />
  {/each}
</div>

<style global>
</style>
